import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import ModalByProps from '#components/m/ModalByProps'
import IconButton from '#components/a/IconButton'
import Button from '#components/a/Button'
import {LoadingButton} from '#components/m/LoadingButton'
import ControlsGroup from '#components/m/ControlsGroup'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import Api from '#services/api'

function RemoveAusbilderModal({ausbilder}) {
  const [showModal, setShowModal] = useState(false)
  const closeModal = () => setShowModal(false)
  const [isRemoving, setIsRemoving] = useState(false)

  const removeAusbilder = async () => {
    setIsRemoving(true)
    try {
      await Api.deleteUserAusbilder(ausbilder.id)
      actions.meineAusbilder.getUserAusbilder()
    } catch (e) {
      actions.error.writeError({error: e})
    } finally {
      setIsRemoving(false)
      closeModal()
    }
  }

  return (
    <div className="ausbilder-entfernen">
      <IconButton icon="removeAusbilder" event={() => setShowModal(true)} />
      <ModalByProps modalIsOpen={showModal} modifier="small">
        <div className="ausbilder-entfernen-modal" data-testid="ausbilder-entfernen-modal">
          <Headline
            modifier="article"
            importance={2}
            text={i18n.t('meine_ausbilder_ausbilder_entfernen_modal_headline')}
          />
          <Text
            text={i18n.t('meine_ausbilder_ausbilder_entfernen_modal_text', [
              `${ausbilder.firstname} ${ausbilder.lastname}`,
            ])}
          />
          <ControlsGroup>
            <Button disabled={false} event={closeModal} text={i18n.t('misc_cancel')} variant="secondary" />
            <LoadingButton
              disabled={isRemoving}
              isLoading={isRemoving}
              event={removeAusbilder}
              text={i18n.t('misc_remove')}
              loadingText={i18n.t('misc_remove_pending')}
              variant="primary"
            />
          </ControlsGroup>
        </div>
      </ModalByProps>
    </div>
  )
}

RemoveAusbilderModal.propTypes = {
  ausbilder: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
  }).isRequired,
}

export default RemoveAusbilderModal
